import { useCallback } from "react";
import { useHistory } from "react-router";

import { AppEventTokenEnum, sendEventToAppMeasurementTool } from "@/utilities/capacitorLogic";

export const useOpenUsageGuide = () => {
  const history = useHistory();
  return useCallback(() => {
    sendEventToAppMeasurementTool(AppEventTokenEnum.NotificationGuide);
    history.push("/usage_guide");
  }, [history]);
};
